export const isActiveStyles =
  "text-lg text-violet-600 font-semibold hover:text-violet-500 duration-100 transition-all ease-in-out";
export const isNotActiveStyles =
  "text-lg text-textColor hover:text-violet-600 duration-100 transition-all ease-in-out";

export const bgColors = [
  "#E9E2FF",
  "#FAE2FF",
  "#FFE2E6",
  "#E2FFE9",
  "#E2F4FF",
  "#FFFFE2",
];
